/**
 * lyrics-editor — 歌詞切行 ＋ 逐句替換（**純函數**；Node 可 import → 真單元測試）
 *   ⚠️ 只換「有草稿」嘅行；冇草稿／空草稿 → 原句保留（唔准靜靜刪嘢）
 */
export function splitLyricLines(lyrics: string): string[] {
  return lyrics.replace(/\r\n/g, "\n").split("\n");
}

export function applyLineEdits(lyrics: string, drafts: Record<number, string>): string {
  return splitLyricLines(lyrics)
    .map((line, i) => {
      const d = drafts[i];
      return typeof d === "string" && d.trim().length > 0 ? d.trim() : line;
    })
    .join("\n");
}
